import { render, staticRenderFns } from "./ComponentSameDirection.vue?vue&type=template&id=e035ce5e"
import script from "./ComponentSameDirection.vue?vue&type=script&lang=js"
export * from "./ComponentSameDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports